import { connect } from 'react-redux'
import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect,
  withRouter
} from "react-router-dom";

const nav = {
    "home" : {title:"Dashboard", nav:[{"title" : "Home"}]},
    "manage_agent": {title:"Pengaturan Agent", nav:[{"title" : "Home"}, {"title" : "Manage Agent"}]},
    "manage_komisi": {title:"Pengaturan Komisi", nav:[{"title" : "Home"}, {"title" : "Manage Komisi"}]},
    "manage_service": {title:"Pengaturan Produk", nav:[{"title" : "Home"}, {"title" : "Manage Produk"}]},
    "history_tx": {title:"Riwayat / History", nav:[{"title" : "Home"}, {"title" : "Riwayat Transaksi"}]},
    "history_fee": {title:"Riwayat / History", nav:[{"title" : "Home"}, {"title" : "Riwayat Komisi"}]},
    "history_bonus": {title:"Riwayat / History", nav:[{"title" : "Home"}, {"title" : "Bonus"}]},
    "history_deposit": {title:"Riwayat / History", nav:[{"title" : "Home"}, {"title" : "Riwayat Deposit"}]},
    "batch_realisasi_komisi": {title:"Realisasi Komisi", nav:[{"title" : "Home"}, {"title" : "Batch Realisasi Komisi"}]},
    "batch_realisasi_bonus": {title:"Realisasi Bonus", nav:[{"title" : "Home"}, {"title" : "Batch Realisasi Bonus"}]},
    "batch_p2p": {title:"P2P Transfer", nav:[{"title" : "Home"}, {"title" : "Batch P2P Transfer"}]}
};

class MetronicSidebar extends Component {
    
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div id="m_aside_left" className="m-grid__item	m-aside-left  m-aside-left--skin-dark ">
                <div id="m_ver_menu" className="m-aside-menu  m-aside-menu--skin-dark m-aside-menu--submenu-skin-dark " data-menu-vertical="true"
                    data-menu-scrollable="false" data-menu-dropdown-timeout="500">
                    <ul className="m-menu__nav m-menu__nav--dropdown-submenu-arrow ">
                        
                        <li className={this.props.current_page==='dashboard'||this.props.current_page===null?'m-menu__item  m-menu__item--active':'m-menu__item'} aria-haspopup="true" >
                            <Link to="/master/home" className="m-menu__link"
                                onClick={(e) => this.props.on_page_changed(e, nav.home)}>
                                <i className="m-menu__link-icon flaticon-squares-1"></i>
                                <span className="m-menu__link-title">
                                    <span className="m-menu__link-wrap">
                                        <span className="m-menu__link-text">
                                            Dashboard
                                        </span>
                                    </span>
                                </span>
                            </Link>
                        </li>

                        <li className="m-menu__section">
                            <h4 className="m-menu__section-text">
                                Master Menu
                            </h4>
                            <i className="m-menu__section-icon flaticon-more-v3"></i>
                        </li>

                        <li className={this.props.current_page==='manage-agent'?'m-menu__item  m-menu__item--active':'m-menu__item'} aria-haspopup="true" data-menu-submenu-toggle="hover">
                            <a className="m-menu__link m-menu__toggle">
                                <i className="m-menu__link-icon flaticon-users"></i>
                                <span className="m-menu__link-text">
                                    Manage Agent
                                </span>
                                <i className="m-menu__ver-arrow la la-angle-right"></i>
                            </a>

                            <div className="m-menu__submenu m-menu__item--open" style={{display:'block'}}>
                                <span className="m-menu__arrow"></span>
                                <ul className="m-menu__subnav">
                                    <li className="m-menu__item m-menu__item--parent" aria-haspopup="true">
                                        <Link to="/master/manage-agent" className="m-menu__link ">
                                            <span className="m-menu__link-text">
                                                Manage Agent
                                            </span>
                                        </Link>
                                    </li>

                                    <li className="m-menu__item" aria-haspopup="true" data-menu-submenu-toggle="hover">
                                        <Link to="/master/manage-agent" 
                                            className="m-menu__link" 
                                            onClick={(e) => this.props.on_page_changed(e, nav.manage_agent)}>
                                            <i className="m-menu__link-bullet m-menu__link-bullet--dot">
                                                <span></span>
                                            </i>
                                            <span className="m-menu__link-text">
                                                Daftar Agent & Downline
                                            </span>
                                        </Link>
                                    </li>

                                    <li className="m-menu__item  m-menu__item--submenu" aria-haspopup="true" data-menu-submenu-toggle="hover">
                                        <Link to="/master/download-agent" className="m-menu__link" onClick={(e) => this.props.on_page_changed(e, nav.manage_agent)}>
                                            <i className="m-menu__link-bullet m-menu__link-bullet--dot">
                                                <span></span>
                                            </i>
                                            <span className="m-menu__link-text">
                                                Download Daftar Agent
                                            </span>
                                        </Link>
                                    </li>
                                    
                                    <li className="m-menu__item" aria-haspopup="true">
                                        <Link to="/master/create-agent" className="m-menu__link">
                                            <i className="m-menu__link-bullet m-menu__link-bullet--dot">
                                                <span></span>
                                            </i>
                                            <span className="m-menu__link-text">
                                                Buat Agent
                                            </span>
                                        </Link>
                                    </li>

                                    <li className="m-menu__item" aria-haspopup="true">
                                        <Link to="/master/create-downline" className="m-menu__link">
                                            <i className="m-menu__link-bullet m-menu__link-bullet--dot">
                                                <span></span>
                                            </i>
                                            <span className="m-menu__link-text">
                                                Buat Downline
                                            </span>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <li className={this.props.current_page==='manage-product'?'m-menu__item  m-menu__item--active':'m-menu__item'} aria-haspopup="true" data-menu-submenu-toggle="hover">
                            <Link to="/master/manage-service" 
                                className="m-menu__link m-menu__toggle" 
                                onClick={(e) => this.props.on_page_changed(e, nav.manage_service)}>
                                <i className="m-menu__link-icon flaticon-network"></i>
                                <span className="m-menu__link-text">
                                    Manage Produk
                                </span>
                            </Link>
                        </li>

                        <li className={this.props.current_page==='batch-realisasi-komisi'?'m-menu__item  m-menu__item--active':'m-menu__item'} aria-haspopup="true" data-menu-submenu-toggle="hover">
                            <Link to="/master/batch-komisi" className="m-menu__link" onClick={(e) => this.props.on_page_changed(e, nav.batch_realisasi_komisi)}>
                                <i className="m-menu__link-icon flaticon-time"></i>
                                <span className="m-menu__link-text">
                                    Batch Realisasi Komisi
                                </span>
                            </Link>
                        </li>

                        <li className={this.props.current_page==='batch-realisasi-bonus'?'m-menu__item  m-menu__item--active':'m-menu__item'} aria-haspopup="true" data-menu-submenu-toggle="hover">
                            <Link to="/master/batch-bonus" className="m-menu__link" onClick={(e) => this.props.on_page_changed(e, nav.batch_realisasi_bonus)}>
                                <i className="m-menu__link-icon flaticon-clipboard"></i>
                                <span className="m-menu__link-text">
                                    Batch Realisasi Bonus
                                </span>
                            </Link>
                        </li>

                        <li className={this.props.current_page==='batch-p2p'?'m-menu__item  m-menu__item--active':'m-menu__item'} aria-haspopup="true" data-menu-submenu-toggle="hover">
                            <Link to="/master/batch-p2p" className="m-menu__link" onClick={(e) => this.props.on_page_changed(e, nav.batch_p2p)}>
                                <i className="m-menu__link-icon flaticon-share"></i>
                                <span className="m-menu__link-text">
                                    Batch P2P Transfer
                                </span>
                            </Link>
                        </li>

                        <li className="m-menu__section">
                            <h4 className="m-menu__section-text">
                                Riwayat / History
                            </h4>
                            <i className="m-menu__section-icon flaticon-more-v3"></i>
                        </li>

                        <li className={this.props.current_page==='riwayat-transaksi'?'m-menu__item m-menu__item--active':'m-menu__item'} aria-haspopup="true" data-menu-submenu-toggle="hover" style={{}}>
                            <Link to="/master/riwayat-transaksi" className="m-menu__link" onClick={(e) => this.props.on_page_changed(e, nav.history_tx)}>
                                <i className="m-menu__link-icon flaticon-layers"></i>
                                <span className="m-menu__link-text">
                                    List Transaksi
                                </span>
                            </Link>
                        </li>
                        
                        <li className={this.props.current_page==='riwayat-komisi'?'m-menu__item  m-menu__item--active':'m-menu__item'} aria-haspopup="true" data-menu-submenu-toggle="hover">
                            <Link to="/master/riwayat-fee" className="m-menu__link" onClick={(e) => this.props.on_page_changed(e, nav.history_fee)}>
                                <i className="m-menu__link-icon flaticon-list-1"></i>
                                <span className="m-menu__link-text">
                                    List Komisi
                                </span>
                            </Link>
                        </li>

                        <li className={this.props.current_page==='riwayat-bonus'?'m-menu__item  m-menu__item--active':'m-menu__item'} aria-haspopup="true" data-menu-submenu-toggle="hover">
                            <Link to="/master/riwayat-bonus" className="m-menu__link" onClick={(e) => this.props.on_page_changed(e, nav.history_bonus)}>
                                <i className="m-menu__link-icon flaticon-notes"></i>
                                <span className="m-menu__link-text">
                                    List Bonus
                                </span>
                            </Link>
                        </li>

                        <li className={this.props.current_page==='riwayat-deposit'?'m-menu__item m-menu__item--active':'m-menu__item'} aria-haspopup="true" data-menu-submenu-toggle="hover" style={{}}>
                            <Link to="/master/riwayat-deposit" className="m-menu__link" onClick={(e) => this.props.on_page_changed(e, nav.history_deposit)}>
                                <i className="m-menu__link-icon flaticon-web"></i>
                                <span className="m-menu__link-text">
                                    List Deposit
                                </span>
                            </Link>
                        </li>

                        <li className="m-menu__section">
                            <h4 className="m-menu__section-text">
                                Support
                            </h4>
                            <i className="m-menu__section-icon flaticon-more-v3"></i>
                        </li>

                        <li className="m-menu__item  m-menu__item--submenu" aria-haspopup="true" data-menu-submenu-toggle="hover">
                            <a href={'mailto:admin@posfin.id?body='} target="_top" className="m-menu__link m-menu__toggle">
                                <i className="m-menu__link-icon flaticon-computer"></i>
                                <span className="m-menu__link-text">
                                    Hubungi Admin
                                </span>
                            </a>
                        </li>

                        <li className="m-menu__item" aria-haspopup="true" data-menu-submenu-toggle="hover">
                            <a href="https://drive.google.com/open?id=1RwRF3kVpDhfPzsdk8Km-O3aPK2ECu1Xd" target="_blank" className="m-menu__link m-menu__toggle">
                                <i className="m-menu__link-icon flaticon-questions-circular-button"></i>
                                <span className="m-menu__link-text">
                                    Dokumen Support
                                </span>
                            </a>
                        </li>

                        <li className="m-menu__item  m-menu__item--submenu" aria-haspopup="true">
                            <p className="m-menu__link" onClick={() => this.props.on_logout()}>
                                <i className="m-menu__link-icon flaticon-logout"></i>
                                <span className="m-menu__link-text">
                                    Logout
                                </span>
                            </p>
                        </li>

                    </ul>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    profile: state.Profile,
    current_page: state.CurrentPage
})

export default connect(mapStateToProps, null)(MetronicSidebar)


// WEBPACK FOOTER //
// ./src/layout/metronic/sidebar.js